import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";

const RegeneratedTargets = ({ isRegenerated, setIsRegenerated, data }: any) => {
	return (
		<Dialog
			header={"Target Price Details"}
			visible={isRegenerated}
			onHide={() => setIsRegenerated(false)}
  			style={{ width: '90vw', height: '90vh' }}    
			modal
		>
			<div
			className="table-container"
			style={{ marginBottom: '0.75rem', width: '100%', minHeight: '95%' }}
			>
				{/* Group Header */}
				<div className="regenerated-group-header">
					{data?.supplier_name}
				</div>

				{/* Data Table */}
				<div className="regenerated-group-table">
					<div className="table-holder">
						<p className="table-header my-0">Negotiation Targets</p>
						<DataTable
							value={data?.script?.targets_table}
							dataKey="objective"
							scrollable
							showGridlines
							scrollHeight="flex"
                            width={"100%"}
                            size="small"
						>
							<Column
								field="negotiation_parameter"
								header="Negotiation Parameters"
							/>
							<Column
								field="objective"
								header="Objectives"
							/>
							<Column
								field="mdo"
								header="MDO (Most Desired Outcome)"
							/>
							<Column
								field="laa"
								header="LAA (Least Acceptable Agreement)"
							/>
							<Column
								field="batna"
								header="BATNA (Best Alternative To Negotiated Agreement)"
							/>
						</DataTable>
					</div>

                    <div className="table-holder">
						<p className="table-header my-0">Negotiation Tactics</p>
						<DataTable
							value={data?.script?.tactics_table}
							scrollable
							dataKey="issue"
							showGridlines
							size="small"
                            
						>
							<Column
								field="negotiation_parameter"
								header="Negotiation Parameters"
							/>
							<Column
								field="issue"
								header="Issue"
							/>
							<Column
								field="key_message"
								header="Key Message"
							/>
							<Column
								field="anticipated_response"
								header="Anticipated Response"
							/>
							<Column
								field="counter_response"
								header="Counter Response"
							/>
							<Column
								field="concessions"
								header="Concessions"
							/>
							<Column
								field="priority"
								header="Priority"
							/>
							
						</DataTable>
					</div>

				</div>
			</div>
		</Dialog>
	);
};

export default RegeneratedTargets;
